import React from 'react'

export const AnalysisStyles: { [key: string]: React.CSSProperties } = {
    container: {
        paddingBottom: 20,
        paddingRight: 20,
        paddingLeft: 20,
        paddingTop: 20,
    },
    content: { width: '100%' },
    buttonViewFullAnalysis: {
        width: 210,
        height: 35,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        border: '1px solid #0086d6',
        borderRadius: 5,
        cursor: 'pointer',
        padding: 0,
        overflow: 'hidden',
    },
    textFullAnalysis: {
        flex: 8,
        fontSize: 12,
        color: '#0086d6',
        flexDirection: 'row',
        display: 'flex',
        paddingLeft: 10,
    },
    buttonSeparator: {
        width: 1,
        height: '70%',
        backgroundColor: '#0086d6',
    },
    iconChevronDown: {
        flex: 2,
        textAlign: 'center',
        color: '#00bfff',
        paddingTop: 4,
    },
}
